/// <amd-module name="Wit/WorkItemModel/WorkItem/FieldDefinitionUtils" />
import { CoreField, FieldFlags } from "Wit/Common/Generated/Constants";
import { IFieldDefinition } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export function isEditable(fieldDefinition: IFieldDefinition): boolean {
    // Special case for fields with "special behavior"
    switch (fieldDefinition.id) {
        case CoreField.AreaPath:
        case CoreField.IterationPath:
            return true;
        case CoreField.Id:
        case CoreField.Rev:
        case CoreField.WorkItemType:
        case CoreField.CreatedBy:
        case CoreField.IsDeleted:
            return false;
    }

    return !isComputed(fieldDefinition);
}

export function isCloneable(fieldDefinition: IFieldDefinition) {
    return checkFlag(fieldDefinition, FieldFlags.Cloneable);
}

export function isComputed(fieldDefinition: IFieldDefinition): boolean {
    return checkFlag(fieldDefinition, FieldFlags.Computed);
}

export function checkFlag(fieldDefinition: IFieldDefinition, flag: FieldFlags): boolean {
    return (fieldDefinition.flags & +flag) !== FieldFlags.None;
}
